import { isNestedTypeProperty, sortPropertyByTypeElementDeveloperName } from '../../sources/type';
import type { TypeElementResponseAPI, TypeMappingAutoAPI } from '../../types/type';
import PropertyDetails from './PropertyDetails';

type Types = Record<string, TypeElementResponseAPI>;

interface Props {
    sourceTypeElementId: string;
    types: Types;
    mapping: TypeMappingAutoAPI | null | undefined;
    visitedTypeElementIds?: Set<string>;
}

const AutoMappingType = ({ sourceTypeElementId, types, mapping, visitedTypeElementIds }: Props) => {
    const sourceType = types[sourceTypeElementId];
    // Track types already on this branch to avoid infinite recursion on cyclic types.
    const nextVisited = new Set(visitedTypeElementIds).add(sourceTypeElementId);

    return (
        <ol key={sourceType.id}>
            {sourceType.properties.sort(sortPropertyByTypeElementDeveloperName).map((property) => {
                const mappedProperty = mapping?.properties.find(
                    (p) => p.sourceTypeElementEntryId === property.id,
                );

                return (
                    <li key={property.id}>
                        <PropertyDetails
                            property={property}
                            types={types}
                            isMatched={!!mappedProperty}
                            showMatch={true}
                        />
                        {isNestedTypeProperty(property) &&
                        !nextVisited.has(property.typeElementId) ? (
                            <AutoMappingType
                                sourceTypeElementId={property.typeElementId}
                                types={types}
                                mapping={mappedProperty?.children}
                                visitedTypeElementIds={nextVisited}
                            />
                        ) : null}
                    </li>
                );
            })}
        </ol>
    );
};

export default AutoMappingType;
